export default "__VITE_ASSET__CZURTT88__"